import React from 'react';
import { TTableHeaderControlButtonProps } from "types/Components/Common/Table/Table"

const TableHeaderControlButton = ({disableHeaderControls, setHeaderControlOpen}: TTableHeaderControlButtonProps) => {
    if(disableHeaderControls) return null

    return (
        <button data-testid="components-tableheadercontrolbutton-button-1" aria-label="Column settings"
            type="button" 
            className={`tw-aspect-sqaure tw-h-8 tw-w-8 tw-rounded hover:tw-bg-edge-strong focus:tw-outline-none`}
            onClick={() => setHeaderControlOpen(true)}
            >
                <i className={`fa fa-bars tw-text-ink-tertiary`}/>
        </button>
    )
}

export default TableHeaderControlButton